let jobsinvo = function(loadPrimary) {
	let t = this;
	let jobs = 0;
	if(t.accessJobsApp){jobs=1;}
	let listinvo = [];
	for (let i in t.InvoicesList) {
		if(t.InvoicesList[i].id){
			listinvo.push(t.InvoicesList[i].id);
		}
	}
	if(listinvo.length>0){
		window.masterGetBilling
		.get("getJobsForBilling/"+window.localuserdata+'/'+listinvo.toString())
		.then((response) => {
			let r = response.data.r;
			if(r.length>0){
				console.log('getJobsForBilling', response.data);
				for (let i in r) {
					let item = r[i];
					for (let e in t.InvoicesList) {
						let v = t.InvoicesList[e];
						if(item.id_invoice==v.id && item.id_customer==v.customer_id){
							// console.log('item.id_invoice='+item.id_invoice, 'job_id='+item.id);
							// t.InvoicesList[e].job=item;
							const updated = {
								id: item.id,
								id_status: item.id_status,
								statusName: item.statusName,
							};
							t.updateDataList(t.InvoicesList, v.id, updated, 'job');
							t.updateDataList(t.InvoicesListResult, v.id, updated, 'job');
						}
					}
				}
				// t.InvoicesListResult = t.InvoicesList;
			}
			t.isLoading = false;
			if(loadPrimary!=undefined && loadPrimary){
				t.tablaInvoKey++;
			}
		})
		.catch((error) => {
			t.isLoading = false;
			console.log(error);
		});
	}else{
		console.log('listinvo empty', listinvo)
	}
};
export default jobsinvo;
